import HTTP from "libs/http";

class Auth extends HTTP {
  async getBot() {
    return await this.post("/bot/get");
  }

  async getCode(phone: string | number, company_id?: string | number) {
    return await this.post("/account/auth_code/get", {
      phone,
      company_id,
    });
  }

  async loginWithPhoneCode({
    company_id,
    bot_id,
    phone,
    auth_code,
  }: {
    company_id: number | string;
    bot_id?: number | string;
    phone: number | string;
    auth_code: number | string;
  }) {
    return await this.post("/account/login/phone_code", {
      company_id,
      bot_id,
      phone,
      auth_code,
    });
  }

  async touristLogin(company_id: string) {
    return await this.post("/account/guest_skip_login", {
      company_id,
    });
  }

  async userCenter() {
    return await this.post("/user_center/get");
  }

  async userProfile() {
    return await this.post("/user_profile/get");
  }

  async updateProfile(params: {
    group_name: string;
    group_data: {};
    old_data: {};
  }) {
    return await this.post("/user_profile/save", params);
  }

  async getCompany(phone: number | string, auth_code: number | string) {
    return await this.post("/account/get/company/list", {
      phone,
      auth_code,
    });
  }

  async dynamicPost(path: string, params: any = {}) {
    return await this.post(path, params);
  }

  async uploadFile(file: any) {
    return await this.post("/file/upload", file, {
      headers: {
        // 'Content-Type': 'multipart/form-data;charset=UTF-8'
        "Content-Type": "multipart/form-data",
      },
    });
  }

  async updateAvatar(uuid: string) {
    return await this.post("/avatar/update", { uuid });
  }

  async resetAvatar() {
    return await this.post("/avatar/reset");
  }

  async switchCompany(company_id: string) {
    return await this.post(`account/switch_token/${company_id}`);
  }

  async ssoLogin(arg: { partner_id: string; token: string }) {
    return await this.post(`/sso/login`, arg);
  }

  async workbench() {
    return await this.post(`/homepage/workbench`);
  }

  async editWorkbench(items: any[]) {
    return await this.post(`/homepage/workbench_save`, { items });
  }

  async userCenterSet(workbench: boolean) {
    return await this.post(`/user_center/set`, { workbench });
  }
}
export default new Auth();
